import {
  LOCIZE_COMMON_TRANSLATION_KEYS,
  LocizeNamespaces,
} from 'app-constants';
import c from 'clsx';
import { AppExternalLink } from 'components/app-external-link';
import { AppLocalizationComponent } from 'components/app-localization-component';
import { CONTACT_INFO } from 'environment';
import { useTranslation } from 'react-i18next';

import styles from './AppContactUs.module.scss';

type AppContactUsProps = {
  className?: string;
  visible?: boolean;
  text?: string;
};

const AppContactUs = ({
  className,
  visible = true,
  text = LOCIZE_COMMON_TRANSLATION_KEYS.contactUsDisclaimer,
}: AppContactUsProps) => {
  const { t } = useTranslation(LocizeNamespaces.common);
  const { contactEmail } = CONTACT_INFO;

  if (!visible) {
    return null;
  }

  return (
    <div className={c(styles.container, className)}>
      <AppLocalizationComponent
        components={{
          email_link: <AppExternalLink to={`mailto:${contactEmail}`} />,
        }}
        locizeKey={text}
        t={t}
        values={{
          contact_email: contactEmail,
        }}
      />
    </div>
  );
};

export default AppContactUs;
